import SearchTable from "../../../primer/Search-Table";
import React from "react";
import {cardTypeOptions} from "../../../../_helpers/commonFunctions";

const CardsSearch = () => {
    const scColumns = [
        {
            name: "Ονομασία Κάρτας",
            field: "name",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Τύπος Κάρτας",
            field: "type",
            editable: false,
            inputType: {
                type: 'dropdownOption',
                options: cardTypeOptions,
            }
        },
        {
            name: "Αριθμός Κάρτας",
            field: "numbering",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Σημειώσεις",
            field: "notes",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Ενεργή",
            field: "isActive",
            editable: false,
            inputType: {
                type: 'dropdownOption',
                options: [
                    {value: "active", label: "Ναι"},
                    {value: "inActive", label: "Όχι"},
                ],
            }
        },
    ]

    const searchFilters = {
        filters: [
            {
                name: "name",
                label: "Ονομασία κάρτας",
                type: "input",
            },
            {
                name: "numbering",
                label: "Αριθμός Κάρτας",
                type: "input",
            },
            {
                name: "showInactive",
                label: "Συμπερίληψη Ανενεργών",
                type: "showInactiveCheckbox",
            },
        ],
        actions: ["quick-edit", "delete"],
    }

    return (
        <div>
            <SearchTable
                tableName="Cards Search"
                key={"Cards Search"}
                hideYearFilter={true}
                allowToggleColumns={true}
                allowPrintResults={false}
                allowPagination={true}
                dataEndpoint={"/cash/search-cards"}
                exportFileName={"Λίστα Καρτών"}
                columns={scColumns}
                data={[]}
                filtersConfig={searchFilters}
            />
        </div>
    )
}

export default CardsSearch;
